/**
 * Template IDs registry — single source of truth for all funnel/template identifiers.
 * Use `TID.<name>` for IDE autocomplete instead of hardcoded strings.
 *
 * @enum {string}
 */
export const TID = {
  DEFAULT: '__default__',
  LETTERS: '__letters__',
  A: 'A',

  // 005 family
  F005AA: 'F005AA',
  T005AA: 'T005AA',
  F005AB: 'F005AB',
  T005AB: 'T005AB',
  F005AC: 'F005AC',
  T005AC: 'T005AC',
  F005AD: 'F005AD',
  T005AD: 'T005AD',
  F005AE: 'F005AE',
  T005AE: 'T005AE',
  F005RR: 'F005RR',
  T005RR: 'T005RR',

  // 006 family
  F006AA: 'F006AA',
  T006AA: 'T006AA',
  F006AB: 'F006AB',
  T006AB: 'T006AB',
  F006AC: 'F006AC',
  T006AC: 'T006AC',
  F006AD: 'F006AD',
  T006AD: 'T006AD',
  F006AE: 'F006AE',
  T006AE: 'T006AE',
  F006RR: 'F006RR',
  T006RR: 'T006RR',

  // Letter funnels
  _99999: '99999',
  _1: '1',
  _2: '2',
  _3: '3',
  _4: '4',
  _5: '5',
  _6: '6',
  _7: '7',
  _8: '8',
  _9: '9',
  _11: '11',
};
